import { setUserProperty } from '../support';

export const events = ({ tracker, condition }) => {
  const amplitude = tracker;
  const { userId, customerId } = condition;

  return {
    SUCCESS(data) {
      const { eventName, payload, adds, appends, sets, setOnces } = data;
      /* adds
       * Array<Object> , Object { key, value }
       * new amplitude.Identify(), [key]에 더할 값 (value)
       */
      /* appends
       * Array<Object> , Object { key, value }
       * new amplitude.Identify(), [key]에 추가 할 값 (value)
       */
      /* sets
       * Array<Object> , Object { key, value }
       * new amplitude.Identify(), [key]에 지정되어야 할 값 (value)
       */

      setUserProperty({ amplitude, data });
      amplitude.getInstance().logEvent(eventName, { customer_id: customerId, user_id: userId, ...payload });
    },
    FAIL(data) {
      const { eventName, payload } = data;
      amplitude.getInstance().logEvent(eventName, { customer_id: customerId, user_id: userId, ...payload });
    },
    RESULT(data) {
      const { eventName, payload, adds, appends, sets, setOnces } = data;

      setUserProperty({ amplitude, data });
      amplitude.getInstance().logEvent(eventName, { customer_id: customerId, user_id: userId, ...payload });
    },
  };
};
